import { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FaArrowRight, FaHeart, FaHandsHelping, FaHandshake, FaSpinner, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import Navbar from "../components/Navbar";
import '../components/coastal-fire.css';
// Getinvolved
// Base URL for the Imarika Foundation Django backend.
// NOTE: fixed the previous "/api/api/api/" typo that was breaking every submission.
const API_BASE = "http://127.0.0.1:8080/api";

const GI_CSS = `
  .gi-hero { background:#043463; padding:clamp(8rem,15vh,11rem) var(--cp) clamp(4rem,7vh,6rem); position:relative; overflow:hidden; }
  .gi-ghost { position:absolute; font-family:'Bebas Neue',sans-serif; font-size:clamp(10rem,25vw,20rem); line-height:.85; color:rgba(238,76,5,.05); right:-3%; top:50%; transform:translateY(-50%); user-select:none; pointer-events:none; }
  .gi-slash { position:absolute; width:3px; background:#ee4c05; border-radius:2px; transform:rotate(12deg); transform-origin:top center; }

  /* Ways to help */
  .gi-ways-grid { display:grid; grid-template-columns:1fr; gap:1.5px; background:rgba(4,52,99,.1); }
  @media(min-width:768px){ .gi-ways-grid { grid-template-columns:repeat(3,1fr); } }
  .gi-way { background:#ffffff; padding:clamp(2rem,5vw,3.5rem) clamp(1.5rem,3vw,2.5rem); display:flex; flex-direction:column; gap:1.25rem; position:relative; overflow:hidden; transition:transform .3s,box-shadow .3s; }
  .gi-way::before { content:''; position:absolute; left:0; top:0; bottom:0; width:3px; background:var(--gc,#ee4c05); transition:width .3s; }
  .gi-way:hover { transform:translateY(-4px); box-shadow:0 24px 48px rgba(4,52,99,.08); }
  .gi-way:hover::before { width:5px; }
  .gi-way-num { font-family:'Bebas Neue',sans-serif; font-size:clamp(3rem,7vw,5.5rem); line-height:1; color:rgba(4,52,99,.05); letter-spacing:.02em; user-select:none; }
  .gi-way-icon { width:52px; height:52px; border-radius:2px; display:flex; align-items:center; justify-content:center; font-size:1.375rem; }
  .gi-way-h3 { font-family:'Bebas Neue',sans-serif; font-size:clamp(1.5rem,3.5vw,2.25rem); letter-spacing:.04em; line-height:1; }
  .gi-way-p { font-size:.875rem; color:#4a5568; line-height:1.8; flex:1; }

  /* Form section */
  .gi-form-grid { display:grid; grid-template-columns:1fr; gap:3rem; }
  @media(min-width:900px){ .gi-form-grid { grid-template-columns:1fr 1fr; align-items:start; } }
  .gi-form-card { background:#ffffff; border:1px solid rgba(4,52,99,.1); border-radius:2px; padding:clamp(2rem,4vw,3rem); }
  .gi-form-h3 { font-family:'Bebas Neue',sans-serif; font-size:clamp(1.5rem,3vw,2rem); letter-spacing:.04em; color:#043463; margin-bottom:.625rem; }
  .gi-form-sub { font-size:.825rem; color:#0e7fbb; line-height:1.75; margin-bottom:1.75rem; }
  .gi-form-body { display:flex; flex-direction:column; gap:1.25rem; }
  
  /* Custom Light Inputs */
  .gi-input { width:100%; background:#f8fafc; border:1px solid rgba(4,52,99,.2); border-radius:2px; padding:.875rem 1rem; font-family:inherit; font-size:.875rem; color:#043463; transition:border-color .2s,box-shadow .2s; outline:none; }
  .gi-input::placeholder { color:#a0aec0; }
  .gi-input:focus { border-color:#ee4c05; box-shadow:0 0 0 3px rgba(238,76,5,.1); }
  .gi-input.error { border-color:#ef4444; }
  .gi-input:disabled { opacity:.6; cursor:not-allowed; }
  .gi-field-err { display:flex; align-items:center; gap:.35rem; font-size:.7rem; color:#ef4444; margin-top:.4rem; }

  .gi-mpesa { background:rgba(14,127,187,.08); border:1px solid rgba(14,127,187,.2); border-radius:2px; padding:1.125rem; }
  .gi-mpesa-h { font-size:.6rem; font-weight:800; letter-spacing:.18em; text-transform:uppercase; color:#0e7fbb; margin-bottom:.875rem; }
  .gi-mpesa-row { display:flex; justify-content:space-between; align-items:center; padding:.375rem 0; border-bottom:1px solid rgba(4,52,99,.1); }
  .gi-mpesa-row:last-child { border-bottom:none; }
  .gi-mpesa-k { font-size:.75rem; color:#4a5568; }
  .gi-mpesa-v { font-family:'Bebas Neue',sans-serif; font-size:1.375rem; letter-spacing:.04em; color:#043463; }
  .gi-success { display:flex; flex-direction:column; align-items:center; text-align:center; gap:1rem; padding:1.5rem 0; }
  .gi-field-lbl { display:block; font-size:.62rem; font-weight:700; letter-spacing:.1em; text-transform:uppercase; color:#043463; margin-bottom:.5rem; }

  /* STK push waiting state */
  .gi-stk-wait { display:flex; flex-direction:column; align-items:center; text-align:center; gap:1rem; padding:2rem 0; }
  .gi-stk-spinner { font-size:2.5rem; color:#0e7fbb; animation:spin 1s linear infinite; }
  .gi-stk-sub { font-size:.8rem; color:#4a5568; line-height:1.7; max-width:280px; }
  .gi-amount-wrap { display:flex; align-items:stretch; }
  .gi-amount-prefix { display:flex; align-items:center; padding:0 .875rem; background:#eef2f6; border:1px solid rgba(4,52,99,.2); border-right:none; border-radius:2px 0 0 2px; font-size:.8rem; font-weight:700; color:#043463; }
  .gi-amount-wrap .gi-input { border-radius:0 2px 2px 0; }

  /* Reveal */
  .gi-rv { opacity:0; transform:translateY(24px); transition:opacity .7s ease,transform .7s ease; }
  .gi-rv.in { opacity:1; transform:none; }
`;

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.add("in"); obs.disconnect(); } }, { threshold:.08 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return ref;
}
const Reveal = ({ children, delay=0, style={} }) => {
  const ref = useReveal();
  return <div ref={ref} className="gi-rv" style={{ transitionDelay:`${delay}ms`,...style }}>{children}</div>;
};

const Toast = ({ type, msg }) => {
  if (!msg) return null;
  return (
    <div role="alert" aria-live="assertive" className={`cf-toast ${type==="ok" ? "cf-toast-ok" : "cf-toast-err"}`}>
      {type==="ok" ? <FaCheckCircle aria-hidden="true" /> : <FaExclamationCircle aria-hidden="true" />}
      <span>{msg}</span>
    </div>
  );
};

// Normalizes Kenyan phone numbers to the 2547XXXXXXXX format Daraja expects.
function normalizePhone(raw) {
  const digits = raw.replace(/\D/g, "");
  if (digits.startsWith("254")) return digits;
  if (digits.startsWith("0")) return `254${digits.slice(1)}`;
  if (digits.startsWith("7") || digits.startsWith("1")) return `254${digits}`;
  return digits;
}
function isValidKenyanPhone(raw) {
  const normalized = normalizePhone(raw);
  return /^254(7|1)\d{8}$/.test(normalized);
}

const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 90000; // stop polling after 90s and show a timeout message

function ContactForm({ formType, color }) {
  const [data, setData]   = useState({ full_name:"", email:"", message:"", phone_number:"", amount:"" });
  const [errs, setErrs]   = useState({});
  const [sub, setSub]     = useState(false);
  const [ok, setOk]       = useState(false);
  const [toast, setToast] = useState({ type:"", msg:"" });
  const [stkStatus, setStkStatus] = useState("IDLE"); // IDLE | PENDING | SUCCESSFUL | FAILED | TIMEOUT
  const pollRef = useRef(null);
  const pollStartRef = useRef(null);
  const isDonate = formType === "donate";

  useEffect(() => () => clearInterval(pollRef.current), []);

  const validate = (n, v) => {
    if (n==="full_name" && !isDonate && !v.trim()) return "Name is required.";
    if (n==="email") {
      if (!v.trim()) return isDonate ? "" : "Email is required.";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return "Enter a valid email.";
    }
    if (n==="phone_number" && isDonate) {
      if (!v.trim()) return "M-Pesa phone number is required.";
      if (!isValidKenyanPhone(v)) return "Enter a valid Safaricom number, e.g. 0712345678.";
    }
    if (n==="amount" && isDonate) {
      if (!v.trim()) return "Amount is required.";
      if (!/^\d+$/.test(v) || Number(v) < 1) return "Enter a valid amount.";
    }
    return "";
  };
  const handleChange = e => { const { name, value } = e.target; setData(p=>({...p,[name]:value})); if (errs[name]) setErrs(p=>({...p,[name]:""})); };
  const handleBlur   = e => { const err = validate(e.target.name, e.target.value); if (err) setErrs(p=>({...p,[e.target.name]:err})); };

  const pollStatus = useCallback((checkoutRequestId) => {
    pollStartRef.current = Date.now();
    pollRef.current = setInterval(async () => {
      if (Date.now() - pollStartRef.current > POLL_TIMEOUT_MS) {
        clearInterval(pollRef.current);
        setStkStatus("TIMEOUT");
        return;
      }
      try {
        const res = await axios.get(`${API_BASE}/payments/status/${checkoutRequestId}/`);
        const status = res.data?.status;
        if (status === "SUCCESSFUL") {
          clearInterval(pollRef.current);
          setStkStatus("SUCCESSFUL");
          setOk(true);
        } else if (status === "FAILED" || status === "CANCELLED") {
          clearInterval(pollRef.current);
          setStkStatus("FAILED");
        }
        // PENDING/PROCESSING: keep polling
      } catch {
        // transient network error — keep polling until timeout
      }
    }, POLL_INTERVAL_MS);
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    const fields = isDonate ? ["phone_number","amount"] : ["full_name","email"];
    const ne = {}; fields.forEach(f=>{ const err=validate(f,data[f]); if (err) ne[f]=err; });
    if (Object.keys(ne).length) { setErrs(ne); return; }

    setSub(true); setToast({type:"",msg:""});

    try {
      if (isDonate) {
        // 1. Kick off the STK Push
        const res = await axios.post(`${API_BASE}/payments/stk-push/`, {
          phone_number: normalizePhone(data.phone_number),
          amount: Number(data.amount),
          full_name: data.full_name,
          email: data.email,
        });
        const checkoutRequestId = res.data?.checkout_request_id ?? res.data?.CheckoutRequestID;
        if (!checkoutRequestId) throw new Error("No checkout request ID returned.");

        setStkStatus("PENDING");
        pollStatus(checkoutRequestId);
      } else {
        // Volunteer / Partner — plain contact submission, no payment involved
        await axios.post(`${API_BASE}/submit/${formType}/`, { form_type: formType, ...data });
        setOk(true);
      }
    } catch (err) {
      setToast({ type:"err", msg: err.response?.data?.message ?? "Something went wrong. Please try again." });
      setStkStatus("IDLE");
    } finally {
      setSub(false);
    }
  };

  const handleRetry = () => {
    clearInterval(pollRef.current);
    setStkStatus("IDLE");
    setToast({ type:"", msg:"" });
  };

  if (ok) return (
    <div className="gi-success">
      <FaCheckCircle style={{ fontSize:"3rem", color:color || "#ee4c05" }} aria-hidden="true" />
      <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.75rem", letterSpacing:".04em", color:"#043463" }}>
        {formType==="donate" ? "Thank You!" : "Received!"}
      </div>
      <p style={{ fontSize:".875rem", color:"#4a5568", lineHeight:1.75, maxWidth:300, textAlign:"center" }}>
        {formType==="donate" ? "Your M-Pesa payment was received successfully. Karibu sana for your generosity." : "We've got your details and will be in touch soon."}
      </p>
    </div>
  );

  // Waiting for the customer to enter their M-Pesa PIN / for the callback to land
  if (isDonate && (stkStatus === "PENDING" || stkStatus === "FAILED" || stkStatus === "TIMEOUT")) {
    return (
      <div className="gi-stk-wait">
        {stkStatus === "PENDING" && (
          <>
            <FaSpinner className="gi-stk-spinner" aria-hidden="true" />
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.5rem", letterSpacing:".04em", color:"#043463" }}>
              Check Your Phone
            </div>
            <p className="gi-stk-sub">
              We've sent an M-Pesa prompt to {data.phone_number}. Enter your PIN to complete your donation of KES {data.amount}.
            </p>
          </>
        )}
        {stkStatus === "FAILED" && (
          <>
            <FaExclamationCircle style={{ fontSize:"2.5rem", color:"#ef4444" }} aria-hidden="true" />
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.5rem", letterSpacing:".04em", color:"#043463" }}>
              Payment Not Completed
            </div>
            <p className="gi-stk-sub">The transaction was cancelled or failed. No amount was charged.</p>
            <button onClick={handleRetry} className="cf-btn cf-btn-orange" style={{ clipPath:"none", borderRadius:2 }}>Try Again</button>
          </>
        )}
        {stkStatus === "TIMEOUT" && (
          <>
            <FaExclamationCircle style={{ fontSize:"2.5rem", color:"#f59e0b" }} aria-hidden="true" />
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.5rem", letterSpacing:".04em", color:"#043463" }}>
              Still Waiting?
            </div>
            <p className="gi-stk-sub">This is taking longer than usual. If you already entered your PIN, your donation may still go through — otherwise, please try again.</p>
            <button onClick={handleRetry} className="cf-btn cf-btn-orange" style={{ clipPath:"none", borderRadius:2 }}>Try Again</button>
          </>
        )}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="gi-form-body" noValidate>
      <Toast type={toast.type} msg={toast.msg} />

      {/* Name */}
      <div>
        <label htmlFor={`${formType}-name`} className="gi-field-lbl">
          Full Name / Organisation {isDonate ? "(optional)" : "*"}
        </label>
        <input id={`${formType}-name`} type="text" name="full_name" value={data.full_name}
               onChange={handleChange} onBlur={handleBlur} autoComplete="name" disabled={sub}
               className={`gi-input ${errs.full_name?"error":""}`} placeholder="e.g. Humphrey Tuva" />
        {errs.full_name && <p className="gi-field-err"><FaExclamationCircle aria-hidden="true" />{errs.full_name}</p>}
      </div>

      {/* Email */}
      <div>
        <label htmlFor={`${formType}-email`} className="gi-field-lbl">
          Email Address {isDonate ? "(optional — for a receipt)" : "*"}
        </label>
        <input id={`${formType}-email`} type="email" name="email" value={data.email}
               onChange={handleChange} onBlur={handleBlur} autoComplete="email" disabled={sub}
               className={`gi-input ${errs.email?"error":""}`} placeholder="e.g. tuva@example.com" />
        {errs.email && <p className="gi-field-err"><FaExclamationCircle aria-hidden="true" />{errs.email}</p>}
      </div>

      {isDonate ? (
        <>
          <div className="gi-mpesa">
            <div className="gi-mpesa-h">Powered by M-Pesa</div>
            <p style={{ fontSize:".78rem", color:"#4a5568", lineHeight:1.7 }}>
              Enter your amount and Safaricom number below — we'll send an STK Push prompt straight to your phone. No manual codes needed.
            </p>
          </div>

          <div>
            <label htmlFor="donate-amount" className="gi-field-lbl">Donation Amount (KES) *</label>
            <div className="gi-amount-wrap">
              <span className="gi-amount-prefix">KES</span>
              <input id="donate-amount" type="text" inputMode="numeric" name="amount" value={data.amount}
                     onChange={handleChange} onBlur={handleBlur} disabled={sub}
                     className={`gi-input ${errs.amount?"error":""}`} placeholder="e.g. 500" />
            </div>
            {errs.amount && <p className="gi-field-err"><FaExclamationCircle aria-hidden="true" />{errs.amount}</p>}
          </div>

          <div>
            <label htmlFor="donate-phone" className="gi-field-lbl">M-Pesa Phone Number *</label>
            <input id="donate-phone" type="tel" name="phone_number" value={data.phone_number}
                   onChange={handleChange} onBlur={handleBlur} disabled={sub}
                   className={`gi-input ${errs.phone_number?"error":""}`}
                   placeholder="e.g. 0712345678" />
            {errs.phone_number && <p className="gi-field-err"><FaExclamationCircle aria-hidden="true" />{errs.phone_number}</p>}
          </div>
        </>
      ) : (
        <div>
          <label htmlFor={`${formType}-msg`} className="gi-field-lbl">Message (optional)</label>
          <textarea id={`${formType}-msg`} name="message" value={data.message} onChange={handleChange}
                    rows={4} className="gi-input" style={{ resize:"none" }} disabled={sub}
                    placeholder="Tell us about yourself or how you'd like to get involved…" />
        </div>
      )}

      <button type="submit" disabled={sub} aria-busy={sub}
              className="cf-btn cf-btn-orange" style={{ width:"100%", justifyContent:"center", clipPath:"none", borderRadius:2 }}>
        {sub ? <><FaSpinner style={{ animation:"spin 1s linear infinite" }} aria-hidden="true" /> {isDonate ? "Sending Prompt…" : "Submitting…"}</> : (isDonate ? "Send M-Pesa Prompt" : "Submit")}
      </button>
      <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
    </form>
  );
}

export default function GetInvolvedPage() {
  return (
    <div className="cf-root">
      <style>{GI_CSS}</style>
      <Helmet><title>Get Involved · Imarika Foundation</title></Helmet>
      <Navbar />

      {/* Hero */}
      <section className="gi-hero">
        <div className="gi-ghost" aria-hidden="true">ACT</div>
        <div className="gi-slash" style={{ height:"clamp(80px,12vh,130px)", right:"clamp(1.5rem,8vw,6rem)", top:"50%" }} aria-hidden="true" />
        <div className="gi-slash" style={{ height:"clamp(50px,7vh,80px)", right:"clamp(3rem,11vw,9.5rem)", top:"52%", opacity:.35 }} aria-hidden="true" />
        <div style={{ maxWidth:700, position:"relative", zIndex:1 }}>
          <span className="cf-label" style={{ color:"#46c5e4" }}>Make a Difference</span>
          <h1 className="cf-h1" style={{ color:"#fff" }}>
            GET<br/><span style={{ color:"#ee4c05" }}>INVOLVED.</span>
          </h1>
          <p style={{ color:"#46c5e4", fontSize:"clamp(.9rem,1.8vw,1.05rem)", lineHeight:1.8, marginTop:"1.5rem", maxWidth:520 }}>
            Every action counts. Whether you donate, volunteer, or partner with us — you are directly transforming lives across Kenya.
          </p>
        </div>
      </section>

      {/* Ways */}
      <section style={{ background:"#f0f4f8" }}>
        <div style={{ maxWidth:"var(--cw)", margin:"0 auto" }}>
          <div className="gi-ways-grid">
            {[
              { num:"01", icon:<FaHeart/>, title:"Donate Today", p:"Support our cause financially. Every shilling reaches communities directly — from scholarships to eye camps.", col:"#ee4c05", bg:"rgba(238,76,5,.1)", id:"donate-form" },
              { num:"02", icon:<FaHandsHelping/>, title:"Volunteer", p:"Give your time, skills, and energy. Join our team of 200+ volunteers making a difference across Kilifi.", col:"#0e7fbb", bg:"rgba(14,127,187,.1)", id:"volunteer-form" },
              { num:"03", icon:<FaHandshake/>, title:"Partner With Us", p:"Organisations, businesses, and institutions — collaborate with us to multiply our community impact.", col:"#46c5e4", bg:"rgba(70,197,228,.1)", id:"partner-form" },
            ].map((w, i) => (
              <Reveal key={w.num} delay={i*80}>
                <a href={`#${w.id}`} className="gi-way" style={{ "--gc":w.col, textDecoration:"none", cursor:"pointer" }}>
                  <div className="gi-way-num">{w.num}</div>
                  <div className="gi-way-icon" style={{ background:w.bg, color:w.col }}>{w.icon}</div>
                  <h3 className="gi-way-h3" style={{ color:"#043463" }}>{w.title}</h3>
                  <p className="gi-way-p">{w.p}</p>
                  <div style={{ display:"flex", alignItems:"center", gap:".5rem", fontSize:".68rem", fontWeight:800, letterSpacing:".1em", textTransform:"uppercase", color:w.col, marginTop:"auto", transition:"gap .2s" }}>
                    <span>Get Started</span><FaArrowRight aria-hidden="true" />
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Forms */}
      <section style={{ background:"#ffffff", padding:"var(--cv) var(--cp)" }}>
        <div style={{ maxWidth:"var(--cw)", margin:"0 auto" }}>

          {/* Donate */}
          <Reveal>
            <div id="donate-form" style={{ scrollMarginTop:"80px", marginBottom:"clamp(3rem,6vw,5rem)" }}>
              <div className="gi-form-grid">
                <div>
                  <span className="cf-label" style={{ color:"#043463" }}>Donate</span>
                  <h2 className="cf-h2" style={{ marginBottom:"1.25rem", color:"#043463" }}>DONATE <span style={{ color:"#ee4c05" }}>TODAY.</span></h2>
                  <p style={{ color:"#4a5568", fontSize:".9rem", lineHeight:1.8, maxWidth:440 }}>
                    Your donation directly funds our five programme pillars — from scholarships for deserving students to life-saving eye surgeries for elderly community members.
                  </p>
                  <div style={{ marginTop:"2rem", display:"flex", flexDirection:"column", gap:"1rem" }}>
                    {["160 students sponsored through secondary school","500+ cataract surgeries performed","13,000+ trees planted across Kilifi"].map(point => (
                      <div key={point} style={{ display:"flex", alignItems:"flex-start", gap:".875rem", fontSize:".875rem", color:"#4a5568" }}>
                        <div style={{ width:"6px", height:"6px", borderRadius:"50%", background:"#ee4c05", flexShrink:0, marginTop:".4rem" }} />
                        {point}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="gi-form-card" style={{ borderTop:"3px solid #ee4c05" }}>
                  <h3 className="gi-form-h3">Make a Donation</h3>
                  <p className="gi-form-sub">Enter your details below — you'll get an M-Pesa prompt on your phone instantly.</p>
                  <ContactForm formType="donate" color="#ee4c05" />
                </div>
              </div>
            </div>
          </Reveal>

          <div style={{ height:"1px", background:"rgba(4,52,99,.1)", margin:"clamp(2rem,4vw,3rem) 0" }} />

          {/* Volunteer */}
          <Reveal>
            <div id="volunteer-form" style={{ scrollMarginTop:"80px", marginBottom:"clamp(3rem,6vw,5rem)" }}>
              <div className="gi-form-grid">
                <div className="gi-form-card" style={{ borderTop:"3px solid #0e7fbb" }}>
                  <h3 className="gi-form-h3">Volunteer Application</h3>
                  <p className="gi-form-sub">Tell us about yourself and we'll be in touch with matching opportunities.</p>
                  <ContactForm formType="volunteer" color="#0e7fbb" />
                </div>
                <div>
                  <span className="cf-label" style={{ color:"#043463" }}>Volunteer</span>
                  <h2 className="cf-h2" style={{ marginBottom:"1.25rem", color:"#043463" }}>JOIN THE <span style={{ color:"#0e7fbb" }}>TEAM.</span></h2>
                  <p style={{ color:"#4a5568", fontSize:".9rem", lineHeight:1.8, maxWidth:440 }}>
                    Our 200+ volunteers are the heartbeat of Imarika Foundation. From mentoring students to running medical camps — there is a role for every skill.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>

          <div style={{ height:"1px", background:"rgba(4,52,99,.1)", margin:"clamp(2rem,4vw,3rem) 0" }} />

          {/* Partner */}
          <Reveal>
            <div id="partner-form" style={{ scrollMarginTop:"80px" }}>
              <div className="gi-form-grid">
                <div>
                  <span className="cf-label" style={{ color:"#043463" }}>Partner</span>
                  <h2 className="cf-h2" style={{ marginBottom:"1.25rem", color:"#043463" }}>PARTNER <span style={{ color:"#46c5e4" }}>WITH US.</span></h2>
                  <p style={{ color:"#4a5568", fontSize:".9rem", lineHeight:1.8, maxWidth:440 }}>
                    Join our growing network of organisations committed to sustainable community development. From corporate CSR to institutional grant-making — let's build together.
                  </p>
                </div>
                <div className="gi-form-card" style={{ borderTop:"3px solid #46c5e4" }}>
                  <h3 className="gi-form-h3">Partnership Enquiry</h3>
                  <p className="gi-form-sub">Tell us about your organisation and how you'd like to collaborate.</p>
                  <ContactForm formType="partner" color="#46c5e4" />
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background:"#043463", padding:"2rem var(--cp)", textAlign:"center", borderTop:"1px solid rgba(255,255,255,.1)" }}>
        <p style={{ fontFamily:"'Outfit',sans-serif", fontSize:".72rem", color:"rgba(255,255,255,.7)" }}>
          © {new Date().getFullYear()} Imarika Foundation · Kenya
        </p>
      </footer>
    </div>
  );
}